import { ArrowLeft } from 'lucide-react'

import { goBack, usePath } from '../router.js'

/**
 * « ← Retour » — TOUTE sous-page de /settings l'affiche en haut, toujours à la
 * même place.
 *
 * Il pointait en dur vers `/settings`. Depuis « Soirées → Saisons », il
 * sautait donc deux niveaux d'un coup et atterrissait sur l'accueil général :
 * ce n'était pas un retour, c'était un raccourci vers la racine.
 *
 * C'est maintenant un vrai retour d'historique. Le repli — utilisé seulement
 * quand on est arrivé directement par l'URL, sans antécédent interne — reste
 * le parent LOGIQUE de la page, jamais la racine.
 */
export function SettingsCrumb({ fallback }: { fallback?: string } = {}) {
  const path = usePath()
  const parent = fallback ?? parentLogique(path)
  return (
    <button type="button" className="lc-crumb" onClick={() => goBack(parent)}>
      <ArrowLeft size={14} aria-hidden="true" /> Retour
    </button>
  )
}

/**
 * Le parent d'une page de réglages, déduit de son chemin.
 *
 * `/settings/soirees/saisons` → `/settings/soirees`, et non `/settings`.
 * Une seule règle, appliquée partout : rien à maintenir route par route.
 */
function parentLogique(path: string): string {
  const segments = path.split('?')[0]!.split('/').filter(Boolean)
  if (segments.length <= 2) return '/settings'
  return `/${segments.slice(0, -1).join('/')}`
}
